"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var availability_const_1 = require("./availability.const");
var AvailabilityService = /** @class */ (function () {
    function AvailabilityService() {
    }
    /**
     * Returns a list of vehicle allocations
     * @param version {string}
     * @param data {object} Params for the endpoint
     * @returns {Promise<VehicleLocationResponse[]>}
     */
    AvailabilityService.prototype.getVehicleLocations = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.VEHICLE_LOCATION_ENDPOINTS.getVehicleLocations.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, data);
    };
    /**
     * Adds a vehicle allocation
     * @param version {string}
     * @param data {VehicleLocationRequest} Vehicle location
     * @returns {Promise<VehicleLocationResponse>}
     */
    AvailabilityService.prototype.addVehicleLocation = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.VEHICLE_LOCATION_ENDPOINTS.postVehicleLocation.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Updates the given vehicle allocation
     * @param version {string}
     * @param uuid {string} Identifier for the vehicle location
     * @param  {VehicleLocationRequest} Vehicle location data to update
     * @returns {Promise<VehicleLocationResponse>}
     */
    AvailabilityService.prototype.updateVehicleLocation = function (uuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.VEHICLE_LOCATION_ENDPOINTS.putVehicleLocation
            .replace('{{version}}', version)
            .replace('{{uuid}}', uuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Deletes the given vehicle allocation
     * @param version {string}
     * @param uuid {string} Identifier for the vehicle location
     * @returns {Promise<any>}
     */
    AvailabilityService.prototype.deleteVehicleLocation = function (uuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.VEHICLE_LOCATION_ENDPOINTS.deleteVehicleLocation
            .replace('{{version}}', version)
            .replace('{{uuid}}', uuid);
        return axios_client_service_1.axiosClientInstance.delete(url);
    };
    /**
     * Returns a list of product availabilities (long distances)
     * @param version {string}
     * @param data {object} Params for the endpoint
     * @returns {Promise<LongDistanceResponse[]>}
     */
    AvailabilityService.prototype.getLongDistanceList = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.LONG_DISTANCE_ENDPOINTS.getLongDistanceList.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, data);
    };
    /**
     * Adds a product availability (long distance)
     * @param version {string}
     * @param data {LongDistanceRequest} Long distance data
     * @returns {Promise<LongDistanceResponse>}
     */
    AvailabilityService.prototype.addLongDistance = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.LONG_DISTANCE_ENDPOINTS.postLongDistance.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Updates the given product availability (long distance)
     * @param version {string}
     * @param {string} uuid - Identifier for the long distance
     * @param {LongDistanceRequest} data - Long distance data to update
     * @returns {Promise<LongDistanceResponse>}
     */
    AvailabilityService.prototype.updateLongDistance = function (uuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.LONG_DISTANCE_ENDPOINTS.putLongDistance
            .replace('{{version}}', version)
            .replace('{{uuid}}', uuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Deletes the given long distance
     * @param {string} uuid - Identifier for the long distance
     * @returns {Promise<any>}
     */
    AvailabilityService.prototype.deleteLongDistance = function (uuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.LONG_DISTANCE_ENDPOINTS.deleteLongDistance
            .replace('{{version}}', version)
            .replace('{{uuid}}', uuid);
        return axios_client_service_1.axiosClientInstance.delete(url);
    };
    /**
     * Returns a list of Unavailabilities. Unavailable vehicles cannot be booked.
     * @param version {string}
     * @param {object} data - Params for the endpoint
     * @returns {Promise<UnavailabilityResponse[]>}
     */
    AvailabilityService.prototype.getUnavailabilityList = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.UNAVAILABILITY_ENDPOINTS.getUnavailabilityList.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, data);
    };
    /**
     * Adds a Unavailability. Make vehicles unavailable. Unavailable vehicles cannot be booked.
     * @param version {string}
     * @param {UnavailabilityRequest} data - Unavailability
     * @returns {Promise<UnavailabilityResponse>}
     */
    AvailabilityService.prototype.addUnavailability = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.UNAVAILABILITY_ENDPOINTS.postUnavailability.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Updates the given Unavailability
     * @param version {string}
     * @param {string} uuid - Identifier for the Unavailability
     * @param {UnavailabilityRequest} data - Unavailability data to update
     * @returns {Promise<UnavailabilityResponse>}
     */
    AvailabilityService.prototype.updateUnavailability = function (uuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.UNAVAILABILITY_ENDPOINTS.putUnavailability
            .replace('{{version}}', version)
            .replace('{{uuid}}', uuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Deletes the given Unavailability
     * @param version {string}
     * @param uuid {string} Identifier for the Unavailability
     * @returns {Promise<any>}
     */
    AvailabilityService.prototype.deleteUnavailability = function (uuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.UNAVAILABILITY_ENDPOINTS.deleteUnavailability
            .replace('{{version}}', version)
            .replace('{{uuid}}', uuid);
        return axios_client_service_1.axiosClientInstance.delete(url);
    };
    return AvailabilityService;
}());
/**
 * AvailabilityService Class Instance
 * @namespace
 */
exports.availability = new AvailabilityService();
